import type { QuotationSource } from './types';

/**
 * Origini salvate nello storico preventivi.
 */
export const RECORDED_SOURCES: QuotationSource[] = [
	'stock_offer',
	'stock_quicko',
	'custom_offer',
	'stellantis',
	'configurator',
];

export const isRecordedSource = (source: unknown): source is QuotationSource =>
	RECORDED_SOURCES.includes(source as QuotationSource);

/**
 * Origini stampate con il template Quicko: canone e noleggiatore arrivano
 * dall'offerta Quicko scelta.
 */
const QUICKO_SOURCES: QuotationSource[] = ['stock_quicko', 'configurator'];

export const isQuickoSource = (source: QuotationSource): boolean =>
	QUICKO_SOURCES.includes(source);
